// zh-TW.js
import TWLocale from 'element-ui/lib/locale/lang/zh-TW'    //引入element語言包
import UserAnswer from './UserAnswer'
import PublishProject from './PublishProject'
import SetUp from './SetUp'
import Appearance from './Appearance'
import DataRecycling from './DataRecycling'
import Preview from './Preview'
import QuesLibrary from './QuestionnaireLibrary'
import Personal from './Personal'
import Mywallet from './Mywallet'
import Quota from './Quota'

const lang = {
  main:{
    // 問卷列表以及公共部分
    message: '消息',
    display: '展示',
    ok: '確定',
    cancel: '取消',
    ok2: '確 定',
    cancel2: '取 消',
    Restore: '恢復',
    delete: '刪除',
    save: '保存',
    save1: '保 存',
    pleaseEnterYourPhoneNumber: '請輸入手機號',
    enterOneUserName: '請輸入用戶名',
    pleaseInputPassword: '請輸入密碼',
    PleaseEnterValidPhoneNumber: '請輸入有效的手機號碼',
    SMSSentSuccessfully: '短信發送成功!',
    MyQuestionnaire: '我的問卷',
    MyExam: '我的考試',
    QuesLibrary: '問卷庫',
    ExamQuestionBank: '考試題庫',
    UserManagement: '用戶管理',
    userInformation: '用戶信息',
    myDownloads: '我的下載',
    myWallet: '我的錢包',
    CustomerServiceCenter: '客服中心',
    liaison: '聯系人',
    advancedSetting: '高級設置',
    QuestionnaireStatus: '問卷狀態',
    CreationTime: '創建時間',
    DeleteTime: '刪除時間',
    PleaseEnterContent: '請輸入內容',
    recycleBin: '回收站',
    title: '標題',
    type: '類型',
    state: '狀態',
    Editing: '編輯中',
    ConscriptionConcentration: '征集中',
    Ended: '已結束',
    inReview: '審核中',
    collectData: '收集數據',
    time: '時間',
    operate: '操作',
    edit: '編輯',
    Preview: '預覽',
    Release: '發布',
    data: '數據',
    PublishProject: '發布項目',
    PreviewProject: '預覽項目',
    CopyProject: '復製項目',
    wipeData: '清空數據',
    deleteItem: '刪除項目',
    questionnaire: '問卷',
    ThereIsCurrentlyNoDataAvailable: '暫無數據',
    PleaseEnterYourLoginPassword: '請輸入登錄密碼',
    whole: '全部',
    Completed: '已完成',
    PleaseSelectAPieceOfData: '請選擇一條數據',
    DataPreparationIsUnderway: '數據準備中，預計5分鐘後完成。前往',
    CanViewProgress: '可查看進度',
    PleaseEnterTheAccountPassword: '請輸入賬戶密碼。',
    DoYouWantToClearTheCurrentData: '是否要清空當前數據？',
    tip: '提示',
    EmptyCanceled: '已取消清空',
    CanBeRestored: '當前項目刪除後將移入回收站,可進行恢復。',
    ImportWasSuccessful: '導入成功',
    ImportFailed: '導入失敗，請重新導入',
    SuccessfullyCopiedProject: '復製項目成功！',
    ImportQuestionnaire: '導入問卷',
    DownloadTemplate: '下載模板',
    DownloadToLocal: '點擊下載模板，將問卷模板下載到本地',
    AutomaticallyGenerateQuestionnaires: '點擊導入問卷，自動生成問卷',
    ModificationPrompt: '修改提示',
    QuestionnaireCollected: '該問卷已收集',
    PausePublishing: '份數據,修改問卷可能會影響已收集的數據，問卷在修改時，會暫停發布，您需要在修改完之後重新發布才可繼續收集數據',
    PausePublishingPrompt: '暫停發布提示',
    PausePublishingPromptText: '您修改問卷時，問卷會暫停發布，您需要在修改完成後重新發布問卷才可繼續進行數據收集，原問卷鏈接不會改變。',
    CreateABlankQuestionnaire: '創建空白問卷',
    ReferenceTemplate: '引用模板',
    EditItem: '編輯項目',
    Dataecycling: '數據回收',
    ExitListPage: '當前問卷編號已經丟失，可能是清除瀏覽器緩存原因。系統將退出到列表頁面。',
    PleaseEnterKeywordSearch: '請輸入關鍵詞搜索',
    SearchFor: '搜索',
    // 問卷設計
    export: '導出',
    import: '導入',
    useTest: '測試使用',
    OptionGrouping: '選項分組',
    OptionsToBeGrouped: '待分組選項',
    GroupedlTips: '提示：請選中左側選項並加入右側分組',
    GroupManagement: '分組管理',
    AddGroup: '添加分組',
    join: '加入',
    GroupName: '分組名稱',
    moveUp: '上移',
    MoveDown: '下移',
    QuestionType: '題型',
    Appearance: '外觀',
    questionBank: '題庫',
    outline: '大綱',
    copy: '復制',
    paste: '粘貼',
    clickQuestionTypeAddQuestion: '點擊題型可添加題目',
    CompleteEditing: '完成編輯',
    QuestionSetting: '題目設置',
    pageNumber: '頁碼',
    WholeQuestionSetting: '整題設置',
    QuestionMustAnswered: '此題必答',
    ProblemCode: '問題編碼',
    ProblemCodeHasBeenUsedAndCannotBeReused: '問題編碼已被使用，不能重復使用',
    uniqueIdentification: '唯一標識，例',
    MaximumNumberOfUploadedFiles: '最大上傳文件數量',
    PleaseSelect: '請選擇',
    DisplayStyle: '顯示樣式',
    lowestScore: '最低分',
    MinimumScoreMustNotBeGreaterThanOrEqualToTheMaximumScore: '最低分不得大於或等於最高分',
    highestScore: '最高分',
    highestScoreMustNotBeLessThanOrEqualToTheLowestScore: '最高分不得小於或等於最低分',
    LogicalSettings: '邏輯設置',
    AddLogicalPrompts: '加入邏輯設置後，答題者可根據回答，從而跳轉或顯示不同題目',
    setUp: '設置',
    MutualExclusionInfluence: '互斥&影響',
    MutualExclusion: '互斥',
    Effect: '影響',
    AdvancedScripting: '高級腳本',
    DisplayLineOfIncidenceMatrixQuestion: '關聯矩陣題顯示行',
    SumOfRestrictedSpecificGravity: '限制比重總和',
    TotalSpecificGravity: '比重總和',
    PromptText: '提示文字',
    LeftPromptText: '左邊提示文字',
    IntermediatePromptText: '中間提示文字',
    PromptTextOnTheRight: '右邊提示文字',
    ManualPositionCorrectionNotAllowed: '不允許手動修正位置',
    InputBoxSize: '輸入框大小',
    small: '小',
    middle: '中',
    big: '大',
    QuestionTypeSwitching: '題型切換',
    SingleRow: '單行',
    multipleRows: '多行',
    Radio: '單選',
    MultipleChoice: '多選',
    RandomArrangementOfRows: '「行」隨機排列',
    RandomArrangementOfColumns: '「列」隨機排列',
    MatrixRowColumnExchange: '矩陣行列交換',
    FillingBoxOnTheMobilePhoneCanSlideToAppear: '手機端填寫框可滑動出現',
    PagingSettings: '分頁設置',
    applyToAll: '應用於全部',
    MinimumTime: '最短時間',
    MinimumTimeToStayOnThisPage: '本頁需停留最短時間',
    EnterSeconds: '輸入秒',
    second: '秒',
    MaximumTime: '最長時間',
    PageNeedsToStayForTheLongestTime: '本頁需停留最長時間',
    MoreSettings: '更多設置',
    PreviousButtonText: '上一頁按鈕文字',
    NextPageButtonText: '下一頁按鈕文字',
    ShowPreviousPagButton: '顯示上一頁按鈕',
    OptionalRange: '可選範圍',
    theLeast: '最少',
    noLimit: '不限',
    term: '項',
    atMost: '最多',
    OptionSettings: '選項設置',
    subset:'分組',
    OptionGroupingPrompt: '當選項多時，通過設置選項分組，可幫助答題者更高效答題。',
    DetailLevel: '詳細程度',
    RandomlyArrangeOptions: '選項隨機排列',
    FixTheLastOption: '固定最後一個選項',
    LimitSpecificGravityMinimumMaximumValue: '限制比重最小/最大值',
    minimumValue: '最小值',
    minimumMustNotBeGreaterThanOrQqualToTheMaximumValue: '最小值不得大於或等於最大值',
    MaximumValue: '最大值',
    OnlySelect: '僅選出',
    place: '位',
    OptionLayout: '選項布局',
    arrange: '列',
    OptionAssociation: '選項關聯',
    LabelSettings: '標簽設置',
    tagName: '標簽名稱',
    PleaseEnterALabelName: '請輸入標簽名稱',
    SettingsFor: '的設置',
    AddAFillInBoxAfterTheOption: '在選項後邊增加填空框',
    ContentRestrictions: '內容限制',
    WordLimit: '字數限制',
    WithinWords: '字內',
    formatLimits: '格式限制',
    FillInAtLeast: '最少填寫',
    FillInAtMost: '最多填寫',
    DefaultText: '默認文本',
    ThisBlankCanBeLeftBlank: '該空可不填',
    questionBank: '題庫',
    problem: '問題',
    increase: '添加',
    FillInTheBlankAttribute: '填空屬性',
    FillInTheBlankNumber: '填空序號',
    WordRange: '字數範圍',
    ThisBlankIsMandatory: '此空必填',
    HowManyWordsCanIFillInAatMost: '最多填寫多少字',
    word: '字',
    BatchAddOptions: '批量添加選項',
    EditTitle: '編輯標題',
    SetTheQuestion: '將題目',
    PleaseSelectAnOption: '請選擇選項',
    SelectedItemsAsOptionsForThisQuestion: '選中項作為本題選項',
    FinishedEditing: '已完成編輯，是否立即發布？',
    continueEditing: '繼續編輯',
    PublishNow: '立即發布',
    percentage:'百分比',
    Selected: '選中',
    notSelected: '未選中',
    show: '顯示',
    NoShow: '不顯示',
    numeral: '數字',
    letter: '字母',
    Chinese: '中文',
    Email: 'Email',
    cellPhoneNumber: '手機號',
    Url: '網址',
    ID: '身份證',
    Item1: '1項',
    Item2: '2項',
    DetailedToDetailedAddress: '詳細到“詳細地址”',
    DetailedToCity: '詳細到“區縣”',
    DetailedTopProvince: '詳細到“省份”',
    maximumValueMustNotBeLessThanOrEqualToTheMinimumValue: '最大值不得小於或等於最小值',
    ReplicatingSuccess: '復制成功',
    PleaseSelectTheTestQuestionFirst: '請先選擇試題',
    ThereAreCurrentlyNoTestQuestionsToPaste: '暫無可粘貼的試題',
    CannotBeEmpty: '不能空',
    PleaseSelectAFile: '請選擇文件',
    fileReadFailure: '文件讀取失敗，請檢查。',
    maximumValueMustNotExceedTheTotalSpecificGravity: '最大值不得大於比重總和',
    ImageUploadQuestionDidNotUploadImages: '圖片上傳題未上傳圖片',
    EnterAtLeastOneOption: '最少輸入一個選項！',
    option: '選項',
    matrix: '矩陣',
    SuccessfullyAppliedToAll: '應用於全部成功！',
    NoOptionsAvailable: '沒有任何選項,請設置!',
    AddedSuccessfully: '添加成功！',
    questionHasAlreadyParticipatedInLogicalSetting: '該題已參與邏輯設置，不能刪除！',
    questionOptionIsAlreadyAssociatedWithAnotherQuestion: '該題目選項已關聯其他題目，不能刪除！',
    firstPageIsTheDefaultPage: '第一頁為默認頁，不能刪除！',
    operationWillPermanentlyDeleteTheData: '此操作將永久刪除該數據, 是否繼續?',
    CancelledDeletion: '已取消刪除',
    other: '其他',
    PleaseRemoveTheOptionFromTheGroup: '請將選項從分組中移除',
    SuccessfullyDeletedThePption: '成功刪除該選項',
    member: '成員',
    MatrixRow: '矩陣行',
    MatrixColumn: '矩陣列',
    minimumOptionsCannotExceedTheMaximumOptions: '最少選項不可多於最多選項',
    QuestionnaireType: '問卷類型',
    AssociatedFrom: '關聯自',
    de: '的',
    Options: '個選項',
    text: '文本',
    CancelFavorite: '取消收藏',
    CancelFailed: '取消失敗',
    CollectionSuccessful: '收藏成功',
    SingleLineInputBox: '單行輸入框',
    MultilineInputBox: '多行輸入框',
    fillInTheBlanks: '填空題',
    CollectToQuestionBank: '收藏到題庫',
    ThereIsCurrentlyNoQuestionBankAvailable: '暫無題庫',
    CannotBeEmpty: '不能為空',
    create: '創建',
    CreateANewQuestionBank: '新建題庫',
    Unclassified: '未分類',
    AddOptions: '添加選項',
    BatchAdd: '批量添加',
    AddOther: '添加【其他】',
    NewOptions: '新增選項',
    multipleChoice: '多項選擇',
    UploadFailed: '上傳失敗！',
    EachRowRepresentsOne: '每行代表一個',
    MultipleCanBeAdded: '可以添加多個',
    MultipleOptionsCanAdded: '每行代表一個選項，可以添加多個選項',
    determine: '判斷',
    MultipleBlankFilling: '多項填空',
    fillInTheBlanks: '填空',
    AddAndFillInTheBlank: '新增填空',
    dropDown: '下拉',
    PictureSelection: '圖片選擇',
    Upload1SheetAtATime: '當次上傳1張',
    UpTo10CopiesCanBeUploaded: '最多可上傳10張',
    modify: '修改',
    ValidationFailed: '驗證失敗',
    CurrentLimitSelection: '當前限制選擇 3 張圖片，如需更換，請刪除上一張圖片在重新選擇！',
    StarRating: '星級評分',
    score: '評分',
    ScaleQuestions: '量表題',
    DateSelection: '日期選擇',
    year: '年',
    month: '月',
    day: '日',
    SelectDate: '選擇日期',
    SortQuestion: '排序題',
    addressLocation: '地址位置',
    ClickToObtainGeographicalLocation: '點擊獲取地理位置',
    CitySelection: '城市選擇',
    PleaseSelectAProvince: '請選擇省份',
    PleaseSelectACity: '請選擇城市',
    PleaseSelectADistrictOrCounty: '請選擇區/縣',
    PleaseFillInTheDetailedAddress: '請填寫詳細地址',
    MatrixRadioSelection: '矩陣單選',
    addRows: '添加行',
    AddColumn: '添加列',
    BatchAddRows: '批量添加行',
    BatchAddColumns: '批量添加列',
    InsertSpaceFiller: '插入填空符',
    KeepAtLeastOneOption: '至少保留一條選項',
    KeepAtLeastOneSubTopic: '至少保留一個子題目！',
    MatrixMultipleSelection: '矩陣多選',
    MatrixStarRating: '矩陣星級評分',
    Scoring: '打分',
    MatrixFillingInTheBlank: '矩陣填空',
    PageNumber: '頁碼',
    UploadFiles: '上傳文件',
    ChooseToUploadFilesWithin10M: '選擇上傳文件(10M以內)',
    Timing: '時間選擇',
    SelectTime: '選擇時間',
    FillInTheBlankHorizontally: '橫向填空',
    TheLengthDeterminesTheWidthOfFillingInTheBlanks: '每個填空符為2個漢字寬度，可連續輸入，其長短決定答題填空寬度，可用鍵盤刪除鍵回退內容',
    Range: '範圍',
    CascadeQuestions: '級聯題',
    EditingOptions: '編輯選項',
    Query: '查詢',
    SpecificGravityQuestion: '比重題',
    Proportion: '比重',
    SetColumnProperties: '設置列屬性',
    SetRowProperties: '設置行屬性',
    CurrentTopic: '當前題目',
    ColumnHeader: '列標題',
    RowHeader: '行標題',
    ValidateProperties: '驗證屬性',
    MinimumWordCount: '最小字數',
    MaximumWordCount: '最大字數',
    MultilineText: '多行文本',
    SingleLineText: '單行文本',
    Integer: '整數',
    FixedLine: '固話',
    DropdownOptions: '下拉選項',
    FileUpload: '文件上傳',
    English: '英文',
    TraditionalChinese: '繁體中文',
    FirstLevelOptions: '一級選項',
    SecondaryOptions: '二級選項',
    ThirdLevelOptions: '三級選項',
    FourthLevelOption: '四級選項',
    ThisOptionCannotBeDeleted: '該選項不可刪除',
    ImportOptions: '導入選項',
    ClickToUpload: '點擊文件到此區域進行上傳',
    Download: '下載',
    BatchAddQuestionTypes: '批量添加題型',
    ImportQuestion: '導入題目',
    PleaseSearchForTagsOrNamesOrQuestioBanks: '請搜索標簽/名稱/題庫',
    SelfBuiltQuestionBank: '自建題庫',
    Refresh: '刷新',
    Quote: '引用',
    ThereIsCurrentlyNoContentAvailable: '暫無內容',
    SystemQuestionBank: '系統題庫',
    QuestionBankName: '題庫名稱',
    TheQuestionBankNameCannotBeEmpty: '題庫名稱不能為空',
    Rename: '重命名',
    DeleteAllQuestionsWithinTheGroup: '刪除分組內所有題目',
    DeleteConfirmation: '刪除確認',
    ScaleSettings: '量表設置',
    ExtremeValueLabel: '極值標簽',
    CustomContent: '自定義內容',
    ScaleSetting: '量級設置',
    Level: '級',
    StartingValue: '起始數值',
    PleaseEnterAValueWithinMax89: '請輸入-9-89以內的數值',
    PleaseEnterAValueWithinMax100: '請輸入-100-100以內的數值',
    PleaseEnterAValueWithinMax10: '請輸入1-10以內的數值',
    Satisfaction: '滿意度',
    Identity: '認同度',
    Willingness: '意願度',
    Importance: '重要度',
    Conformance: '符合度',
    Perception: '感知度',
    Feasibility: '可行性',
    Custom: '自定義',
    VeryDissatisfied: '非常不滿意',
    VerySatisfied: '非常滿意',
    StronglyDisagree: '非常不贊同',
    StronglyAgree: '非常贊同',
    VeryReluctant: '非常不願意',
    VeryWilling: '非常願意',
    VeryUnimportant: '非常不重要',
    VeryImportant: '非常重要',
    VeryInconsistent: '非常不符合',
    VeryConsistent: '非常符合',
    Senseless: '毫無感覺',
    VeryStrong: '十分強烈',
    Impossible: '不可能',
    InAllLikelihood: '極有可能',
    ScoreSetting: '分值設置',
    ScoreConversionRatioOfThisQuestion: '該題分值轉換比例',
    ClosedLoopOrNot: '是否閉環',
    FillingRestrictions: '填寫限制',
    MinimumMustNotBeGreaterThanOrEqualToMaximum: '最少字數不得大於等於最大字數',
    MaximumMustNotBLessThanOrEqualToMinimum: '最多字數不得小於等於最少字數',
    JumpLogic: '跳轉邏輯',
    JumpLogics: '條跳轉邏輯',
    UnconditionalSkipQuestions: '無條件跳題',
    SkipQuestionsAccordingToConditions: '按條件跳題',
    AddLogic: '新增邏輯',
    AfterAnsweringThisQuestionJumpTo: '回答此題後跳轉到',
    PleaseSelectAQuestion: '請選擇題目',
    Provided: '如果',
    StartingScore: '起始分數',
    EndScoreScore: '結束分數',
    ThenJumpTo: '則跳轉到',
    DisplayLogic: '顯示邏輯',
    BarDisplayLogic: '條顯示邏輯',
    DisplayThisQuestionIfTheFollowingConditionsAreMet: '滿足以下條件顯示該題',
    SetConditionsAndTestQuestionsToBeDisplayed: '設置條件以及需要顯示的試題',
    Just: '且',
    Perhaps: '或',
    Arbitrarily: '任意',
    EqualTo: '等於',
    GreaterThan: '大於',
    LessThan: '小於',
    Betweenness: '介於',
    AnyOption: '任意選項',
    NormalEndIncludedInTheResult: '正常結束（計入結果）',
    EarlyTerminationDoesNotCountTowardsResults: '提前結束（不計入結果）',
    AddConditions: '添加條件',
    When: '當',
    ThisQuestion: '該題',
    PleaseSelectACondition: '請選擇條件',
    ThenDisplay: '則顯示',
    AddTestQuestions: '添加試題',
    AddDisplayLogic: '添加顯示邏輯',
    NewlyAdded: '新增',
    Give: '與',
    MutualInfluence: '互相影響',
    Enter: '請輸入',
    Help: '幫助',
    GiveAnExample: '舉例',
    MeetTheFollowingRequirements: '符合以下',
    ShowThisIssueWhenConditionsAreMet: '條件時顯示此問題',
    NormalCompletion: '正常完成',
    ShowWhen: '時顯示',
    PleaseFillOInThisItem: '請填寫本項內容',
    PleaseSelectTheFollowingImage: '請選擇以下圖片',
    PleaseSelectAnOption: '請選擇一個選項',
    SelectMultipleOptions: '請選擇以下選項 (多選)',
    SelectTheFollowingOptions: '請選擇以下選項',
    SortTheFollowingOptions: '請給以下選項排序',
    RateTheFollowingItems: '請給以下各項打分',
    FillInTheFollowingInformation: '請填寫以下內容',
    Headings: '段落標題',
    NextPage: '下一頁',
    LastPage: '上一頁',
    FullName: '姓名',
    Age: '年齡',
    Year: '歲',
    ContactInformation: '聯系方式',
    PercentageOfEachItem: '請選擇以下各項所占的百分比',
    EvaluateThisProject: '請您對此項目進行評價',
    FillInMemberInformation: '請填寫你的團隊成員信息',
    Correct: '正確',
    Error: '錯誤',
    SingleChoice: '單選題',
    MultipleChoiceQuestions: '多選題',
    TrueOrFalse: '判斷題',
    ParagraphDescription: '段落說明',
    TextFilling: '文本填寫',
    QuestionCitation: '問題引用',
    SearchForIssueLabelsOrIssueTitles: '請搜索問題標簽/問題標題',
    BatchReference: '批量引用',
    ProblemLabel: '問題標簽',
    QuestionTitle: '問題標題',
    AffiliatedQuestionBank: '所屬題庫',
    PersonalTemplate: '個人模板',
    SystemTemplate: '系統模板',
    TimeCited: '被引用次數',
    FilingNumber: '©2009-2026 北京東方艾學信息技術有限責任公司 京ICP備19053717號-1',
    Disable: '禁用'
  },
  ImportQuestion: {
    TextImport: '文本導入',
    TextEditing: '文本編輯',
    ExampleAndHelp: '示例&幫助',
    ClearText: '清空文本',
    PasteTheDocumentHere: '請將已準備好的文檔按示例格式復制粘貼到這裏',
    QuestionPreview: '題目預覽',
    CreateProject: '創建項目',
    WelcomeMessage: '歡迎語',
    PreviewExample: '預覽示例',
    Example1: '中國的火警報警電話是',
    Example2: '東方神采多選題支持哪些計分方式？',
    Example3: '臘月的最後一天為除日，所以臘月的最後一天晚上叫除夕。',
    Example4: '《史記》的作者是？',
    Example5: '請確認上述問題的答題，然後提交',
    ScoringMethod1: '全部答對才得分',
    ScoringMethod2: '答對幾項得幾分，答錯不得分',
    ScoringMethod3: '每個選項都有相應分值',
    Yes: '是',
    No: '否',
    FormatDescription: '格式說明',
    FormatDescription1: '題目標題最好以數字開頭；',
    FormatDescription2: '建議在題目後面添加題型標識，未標識的題目系統將自動識別；',
    FormatDescription3: '目前可識別的題型標識包括：【歡迎語】、【單選題】、【多選題】、【判斷題】、【填空題】、【段落說明】；',
    FormatDescription4: '如果無法正確識別，請嘗試在題目與題目之間加入空行；',
    FormatDescription5: '請勿在選項與選項之間空行。',
    FormatDescription6: '在【單選題】、【多選題】、【判斷題】選項後增加“【文本填寫】”字樣，選項後會增加文本輸入框。',
    FormatDescription7: '在【單選題】、【多選題】、【判斷題】選項後，或者【填空題】題目後增加“---JumpToQ4”、“---NormalEnd”、“---EarlyTermination”字樣，增加跳轉邏輯。',
    FormatDescription8: '在題目後面添加“【ProblemLabel：標簽1】”字樣，添加問題標簽。',
    FormatDescription9: '結束語：結束語分為',
    ClearPrompt: '確認清空文本嗎？清空後，將無法恢復已輸入文本',
    ErrorMessage: '錯誤信息',
    ProjectTitle: '項目標題',
    CorrectAnswer: '正確答案',
    Creating: '正在創建',
    CreatedSuccessfully: '創建成功',
    ConclusionNormalEnd: '結束語-正常結束',
    ConclusionEarlyTermination: '結束語-提前結束'
  },
  Paper: {
    Title: '問卷標題',
    Depict: '感謝您能抽出幾分鐘時間來參加本次答題，現在我們就馬上開始吧！',
    endPageNormalMsg: '您已完成本次問卷，感謝您的幫助與支持',
    endPageAdvanceMsg: '不好意思，您不太適合本次調查，謝謝您的參與',
  },
  AdvancedScript: {
    ConditionalFunctionsAndUsage: '條件函數/使用',
    Normal: '普通',
    Normal1: '(單選、下拉、圖片選擇、判斷、多選)',
    Normal2: '(量表、星級)',
    Normal3: '(矩陣單選)',
    Normal4: '(矩陣星級)',
    Normal5: '(矩陣填空、矩陣組合)',
    Function: '函數',
    Exist1: '多選存在選項',
    Exist2: '矩陣多選存在選項',
    Exist3: '多選不存在選項',
    Exist4: '矩陣多選不存在選項',
    Include1: '多選包含選項',
    Include2: '矩陣多選包含選項',
    IsShow: '試題顯示',
    IsHide: '試題不顯示',
    IsAnswered: '試題已答',
    Help: '執行函數/使用',
    Help1: '矩陣行顯示',
    Help2: '矩陣行隱藏',
    Help3: '試題顯示',
    Help4: '試題隱藏',
    Help5: '賦值',
    Help6: '跳轉到',
    Help7: '復原跳轉邏輯',
    Illustrate: '說明',
    Illustrate1: '試題編碼',
    Illustrate2: '行號',
    Illustrate3: '選項序號',
    Illustrate4: '選中選項數量',
    Illustrate5: '並且',
    Illustrate6: '或者'
  },
  login: {
    accountLogin: '賬號登錄',
    quickLogin: '快捷登錄',
    userRegistration: '用戶註冊',
    changePassword: '修改密碼',
    forgotPassword: '忘記密碼',
    login: '登錄',
    pleaseEnterTheVerificationCode: '請輸入驗證碼',
    obtainVerificationCode: '獲取驗證碼',
    registerNow: '立即註冊',
    returnToLogin: '返回登錄',
    pleaseEnterNewPassword: '請輸入新密碼',
    loginWasSuccessful: '註冊成功！',
    LoginSucceeded: '登錄成功！',
    LogOutOfLogin: '退出登錄',
  },
  titleEditor: {
    QuoteTheAnswerFromThePreviousQuestion: '引用前面題目的答案',
    introduce: '引入',
    quote: '引用',
    CiteTheAnswersToThePreviousQuestionsToTheFollowingText: '將前面題目的答案引用到下文',
    ThereAreCurrentlyNoTestQuestionsToCite: '暫無可引用的試題',
    PleaseSelectTheTestQuestion: '請選擇試題',
    QuestionNumber: '題號',
    SeniorEditor: '高級編輯'
  },
  MyDownloads: {
    FileName: '文件名稱',
    FileType: '文件類型',
    Time: '時間',
    FileSize: '文件大小',
    State: '狀態',
    CanDownloaded: '可以下載',
    Download: '下載',
    DataPreparationProgress: '數據準備中',
    CanDownloaded: '可以下載',
    ExportException: '導出異常',
    DataExpiration: '數據過期'
  },
  ...UserAnswer,
  ...PublishProject,
  ...SetUp,
  ...Appearance,
  ...DataRecycling,
  ...Preview,
  ...QuesLibrary,
  ...Personal,
  ...Mywallet,
  ...Quota,
  ...TWLocale
};
export default lang